import { Fragment } from "preact";
import { useState, useMemo } from 'preact/hooks';
import { infos_to_display, caption_ellipsis } from "../settings";
import { MwlIcons } from "../components/MwlIcons";

export const Description = ({ image }) => {
  const [ showFullDescription, setShowFullDescription ] = useState(false);
  const hasLongCaption = (image.caption?.length ?? '') > 150;
  const caption = useMemo(() => {
    if (!caption_ellipsis || !hasLongCaption || showFullDescription) {
      return image.caption;
    }
    return `${image.caption.substr(0, 150)}...`;
  }, [showFullDescription, hasLongCaption, image?.caption]);

  if (!infos_to_display.caption || !caption) {
    return null;
  }

  return (
    <Fragment>
      <p className="visible">
        <span className="caption" dangerouslySetInnerHTML={{ __html: caption }}></span>
        {caption_ellipsis && hasLongCaption &&
          <span className="toggle-full-description" onClick={() => setShowFullDescription(!showFullDescription)}>
            {showFullDescription ? <MwlIcons icon="minus" /> : <MwlIcons icon="plus" />}
          </span>
        }
      </p>
    </Fragment>
  );
};
